"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = require("lodash");

var _fetch = _interopRequireDefault(require("./utils/fetch"));

var _wujiQueryGenerate = _interopRequireDefault(require("./utils/wujiQueryGenerate"));

var _dataStore = _interopRequireDefault(require("./dataStore"));

var _common = require("./utils/common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var baseApi = '/api/xy/access';
var apiObj = {
  // 查看单条配置 GET
  getApi: "//{host}".concat(baseApi, "/object/{objectid}?appid={appid}&schemaid={schemaid}&projectid={projectid}&_uuid={uuid}"),
  // 修改单条配置 POST
  editApi: "//{host}".concat(baseApi, "/object/patch/{objectid}?appid={appid}&schemaid={schemaid}&projectid={projectid}&_uuid={uuid}"),
  // 新增单条配置 POST
  addApi: "//{host}".concat(baseApi, "/object?appid={appid}&schemaid={schemaid}&projectid={projectid}&_uuid={uuid}"),
  // 删除单条配置 POST
  deleteApi: "//{host}".concat(baseApi, "/object/delete/{objectid}?appid={appid}&schemaid={schemaid}&projectid={projectid}&_uuid={uuid}"),
  // 获取列表数据 GET
  listApi: "//{host}".concat(baseApi, "/object?appid={appid}&schemaid={schemaid}&projectid={projectid}&_uuid={uuid}"),
  // 获取列表总条数 GET
  listCountApi: "//{host}".concat(baseApi, "/object?appid={appid}&schemaid={schemaid}&count=1&projectid={projectid}&_uuid={uuid}"),
  // 获取扁平化字段 GET
  fieldListApi: "//{host}".concat(baseApi, "/schema/{schemaid}?appid={appid}&projectid={projectid}")
};
/**
 * 无极请求的基础类
 */

var WujiApi = /*#__PURE__*/function () {
  function WujiApi(options) {
    (0, _classCallCheck2["default"])(this, WujiApi);

    _initialiseProps.call(this);

    // 收集异常的集合
    this.errMsg = options.errMsg;
    this.uuid = options.uuid;
  }

  (0, _createClass2["default"])(WujiApi, [{
    key: "convertParam",
    value: function convertParam(param) {
      if (param === 0) {
        return param;
      }

      if (!param) {
        return '';
      }

      return encodeURIComponent(param);
    }
  }, {
    key: "getApiByType",
    value: function getApiByType(type, options) {
      if (!apiObj[type]) return;
      var api = apiObj[type].replace('{host}', _dataStore["default"].envHost).replace('{projectid}', this.convertParam(_dataStore["default"].projectId)).replace('{appid}', this.convertParam(options.appId)).replace('{schemaid}', this.convertParam(options.schemaId)).replace('{objectid}', this.convertParam(options.objectId)).replace('{uuid}', this.convertParam(this.uuid)); // 如果有dataStore需要透传的query，默认添加

      return (0, _common.appendUrlSearchParams)(api, _dataStore["default"].fetchQuery);
    }
  }, {
    key: "customHeaders",
    value: function customHeaders() {
      var _window = window,
          _window$xy_runtime_ut = _window.xy_runtime_utils,
          utils = _window$xy_runtime_ut === void 0 ? {} : _window$xy_runtime_ut;
      var getXyHeaders = utils.getXyHeaders;
      var headers = typeof getXyHeaders === 'function' ? getXyHeaders() : {};
      return headers;
    }
    /**
     * 获取单个表的数据列表
     * @param table table实例
     * @param isCount 请求数据总数
     */

  }]);
  return WujiApi;
}();

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.getDataList = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(table) {
      var isCount,
          api,
          queryStr,
          result,
          that,
          _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isCount = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              api = _this.getApiByType('listApi', {
                appId: table.appId,
                schemaId: table.schemaId
              });
              queryStr = (0, _wujiQueryGenerate["default"])(table, isCount);
              _context.next = 5;
              return (0, _fetch["default"])("".concat(api + queryStr).concat(isCount ? '&count=1' : ''), {
                headers: _objectSpread({
                  'Content-type': 'text/plain; charset=UTF-8'
                }, _this.customHeaders()),
                method: 'GET'
              });

            case 5:
              result = _context.sent;

              if (result.code !== 200) {
                _this.errMsg.push("".concat(table.appId, ".").concat(table.schemaId, "\u7684getDataList\u8BF7\u6C42\u5F02\u5E38:").concat(result.error));
              } // code的判断收敛在该文件中


              if (!(result.code === 200 && result.data)) {
                _context.next = 13;
                break;
              }

              if (!Array.isArray(result.data)) {
                _context.next = 12;
                break;
              }

              that = _this;
              result.data.forEach(function (dt) {
                that.fixSchemaField(dt, table.schemaList);
              });
              return _context.abrupt("return", result.data);

            case 12:
              return _context.abrupt("return", result.data.total);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.getDataDetail = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(table, options) {
      var api, result;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _this.getApiByType('getApi', {
                appId: table.appId,
                schemaId: table.schemaId,
                objectId: options.objectId
              });
              _context2.next = 3;
              return (0, _fetch["default"])(api, {
                headers: _objectSpread({
                  'Content-type': 'text/plain; charset=UTF-8'
                }, _this.customHeaders()),
                method: 'GET'
              });

            case 3:
              result = _context2.sent;

              if (result.code !== 200) {
                _this.errMsg.push("".concat(table.appId, ".").concat(table.schemaId, ".").concat(options.objectId, "\u7684getDataDetail\u8BF7\u6C42\u5F02\u5E38:").concat(result.error));
              } // code的判断收敛在该文件中


              if (!(result.code === 200 && result.data)) {
                _context2.next = 8;
                break;
              }

              _this.fixSchemaField(result.data, table.schemaList);

              return _context2.abrupt("return", result.data);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.addDataDetail = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(table, data) {
      var api, result;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.fixSchemaField(data, table.schemaList);

              api = _this.getApiByType('addApi', {
                appId: table.appId,
                schemaId: table.schemaId
              });
              _context3.next = 4;
              return (0, _fetch["default"])(api, {
                headers: _objectSpread({
                  'Content-type': 'text/plain; charset=UTF-8'
                }, _this.customHeaders()),
                method: 'POST',
                body: JSON.stringify(data)
              });

            case 4:
              result = _context3.sent;

              if (result.code !== 200) {
                _this.errMsg.push("".concat(table.appId, ".").concat(table.schemaId, "\u7684addDataDetail\u8BF7\u6C42\u5F02\u5E38:").concat(result.error));
              }

              if (!(result.code === 200 && result.data)) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", result.data[table.primaryKey]);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.editDataDetail = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(table, data) {
      var curData, api, result;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              curData = (0, _lodash.cloneDeep)(data);

              _this.fixSchemaField(curData, table.schemaList);

              api = _this.getApiByType('editApi', {
                appId: table.appId,
                schemaId: table.schemaId,
                objectId: curData[table.primaryKey]
              });
              _context4.next = 5;
              return (0, _fetch["default"])(api, {
                headers: _objectSpread({
                  'Content-type': 'text/plain; charset=UTF-8'
                }, _this.customHeaders()),
                method: 'POST',
                body: JSON.stringify(curData)
              });

            case 5:
              result = _context4.sent;

              if (result.code !== 200) {
                _this.errMsg.push("".concat(table.appId, ".").concat(table.schemaId, ".").concat(data[table.primaryKey], "\u7684editDataDetail\u8BF7\u6C42\u5F02\u5E38:").concat(result.error));
              }

              return _context4.abrupt("return", (result === null || result === void 0 ? void 0 : result.data) === true);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.deleteDataDetail = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(table, options) {
      var api, result;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              api = _this.getApiByType('deleteApi', {
                appId: table.appId,
                schemaId: table.schemaId,
                objectId: options.objectId
              });
              _context5.next = 3;
              return (0, _fetch["default"])(api, {
                method: 'POST',
                headers: _this.customHeaders()
              });

            case 3:
              result = _context5.sent;

              if (result.code !== 200) {
                _this.errMsg.push("".concat(table.appId, ".").concat(table.schemaId, ".").concat(options.objectId, "\u7684deleteDataDetail\u8BF7\u6C42\u5F02\u5E38:").concat(result.error));
              }

              return _context5.abrupt("return", result);

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.getSchemaList = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(appId, schemaId) {
      var api, result;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              api = _this.getApiByType('fieldListApi', {
                appId: appId,
                schemaId: schemaId
              });
              _context6.next = 3;
              return (0, _fetch["default"])(api, {
                method: 'GET',
                headers: _this.customHeaders()
              });

            case 3:
              result = _context6.sent;

              if (result.code !== 200) {
                _this.errMsg.push("".concat(appId, ".").concat(schemaId, "\u7684fieldListApi\u8BF7\u6C42\u5F02\u5E38:").concat(result.error));
              } // code的判断收敛在该文件中


              if (!(result.code === 200 && result.data)) {
                _context6.next = 7;
                break;
              }

              return _context6.abrupt("return", result.data.fields);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x10, _x11) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.fixSchemaField = function ($data, schemaList) {
    var data = $data;
    Object.keys(data).forEach(function (key) {
      var findSchema = schemaList.find(function (schema) {
        return schema.id === key;
      });

      if (!findSchema && key !== '_id') {
        delete data[key];
      }
    });
  };
};

var _default = WujiApi;
exports["default"] = _default;